export const productsIndex_AU = process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_INDEX_AU || '';//methven-au
export const productsIndex_NZ = process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_INDEX_NZ || '';
export const productsSearchIndex_AU = process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_SEARCH_INDEX_AU || productsIndex_AU;//methven-au-main
export const productsSearchIndex_NZ = process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_SEARCH_INDEX_NZ || productsIndex_NZ;
export const contentIndex_AU = process.env.NEXT_PUBLIC_ALGOLIA_CONTENT_INDEX_AU || '';
export const contentIndex_NZ = process.env.NEXT_PUBLIC_ALGOLIA_CONTENT_INDEX_NZ || '';

export const productsQuerySuggestionsIndex_AU =
  process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_QUERY_SUGGESTIONS_INDEX_AU || '';
export const productsQuerySuggestionsIndex_NZ =
  process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_QUERY_SUGGESTIONS_INDEX_NZ || '';
